// @flow
import { renderToStaticMarkup } from 'react-dom/server';

export default (element: React$Element<any>, mediaType?: string = 'text/html') => {
    const markup = renderToStaticMarkup(element);
    return `data:${mediaType};charset=UTF-8,${encodeURIComponent(markup)}`;
};
